import { render, staticRenderFns } from "./adverts.vue?vue&type=template&id=33803f0f"
import script from "./adverts.vue?vue&type=script&lang=js"
export * from "./adverts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports